export class TableFilter {
    constructor(
        public filter: { filters: Array<any>; logic: string },
        public pageNumber: number,
        public pageSize: number,
        public sort: { dir: string; field: string }
    ) {}
}
